/**
 * @group Legal
@summary <blockquote>Supported legal jurisdictions and framework toggles.</blockquote>
 * @internal
 */
export const LEGAL_JURISDICTIONS = {
  POPIA: { enabled: true, regions: ['ZA'] }
} as const;


